import React from 'react';

const RecallIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.8224 10H7.33293C4.39814 10 2 12.42 2 15.3815V17.6154V22H11.2"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M12.1491 2H18.8509C21.642 2 24 4.39829 24 7.435V8.227V10H7V8.227V7.435C7 4.39829 9.35796 2 12.1491 2Z"
      stroke="#00619E"
      strokeWidth="2"
    />
    <path
      d="M29 8.58C29 9.21 28.63 9.78 28.05 10.03L26.32 10.79C24.8 11.45 23 10.47 23 9C23 7.9 24.02 7 25.3 7H27.42C28.29 7 29 7.71 29 8.58Z"
      fill="#00619E"
    />
    <path
      d="M2 8.58077C2 9.21108 2.3552 9.78136 2.912 10.0315L4.5728 10.7919C6.032 11.4522 7 10.4577 7 8.98699C7 7.88645 6.7808 7 5.552 7H3.5168C2.6816 7 2 7.71035 2 8.58077Z"
      fill="#00619E"
    />
    <path
      d="M1 23C1 24.65 2.4 26 4.11111 26H4.88889C6.6 26 8 24.65 8 23H1Z"
      fill="#00619E"
    />
    <path
      d="M12 16H15"
      stroke="#00619E"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M7 18C8.10457 18 9 17.1046 9 16C9 14.8954 8.10457 14 7 14C5.89543 14 5 14.8954 5 16C5 17.1046 5.89543 18 7 18Z"
      fill="#00619E"
    />
    <path
      d="M11.7344 30L21 13.9959L25.6346 22.001L30.2656 30L11.7344 30Z"
      stroke="#00AED9"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <circle cx="21" cy="27" r="1" fill="#00AED9" />
    <circle cx="21" cy="27" r="1" stroke="#00AED9" />
    <path
      d="M21 21L21 24"
      stroke="#00AED9"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export default RecallIcon;
